import axiosCall from './interceptor';
import URL from '../helper';

export const getChannels = async (sourceId, sourceType) => {
  const url = `${URL.DESIGN_SYSTEM_URL}channel/map?id=${sourceId}&type=${sourceType}`;
  let response = await axiosCall('get', url);
  return response.data.data;
}
